import { render, staticRenderFns } from "./ApplicationAdminConfirmation.vue?vue&type=template&id=68b9a5b6"
import script from "./ApplicationAdminConfirmation.vue?vue&type=script&lang=js"
export * from "./ApplicationAdminConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports